import React, { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

import ChevronLeft from '@videoblocks/react-icons/ChevronLeft';
import ChevronRight from '@videoblocks/react-icons/ChevronRight';

export enum SlideButtonType {
  NEXT = 'next',
  BACK = 'back',
}
export interface SlideButtonPropTypes {
  type: SlideButtonType;
  className?: string;
  disabled?: boolean;
  hidden?: boolean;
  onClick: () => void;
}

const SlideButton = ({
  type = SlideButtonType.NEXT,
  className,
  onClick,
  disabled,
  ...rest
}: SlideButtonPropTypes): ReactElement => {
  const Icon = type === SlideButtonType.NEXT ? ChevronRight : ChevronLeft;

  const classes = twMerge(
    'w-9 h-9 p-2',
    'flex rounded-full icon-button border-gray-200 border-solid bg-white',
    className
  );

  return (
    <button
      style={{
        boxShadow:
          '0px 4px 10px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.3)',
      }}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={`Scroll ${type.toLowerCase()}`}
      aria-hidden={true}
      tabIndex={0}
      {...rest}
    >
      <Icon className="w-full" />
    </button>
  );
};

export default SlideButton;
